__webpack_require__.p = "https://www.ikea.com/se/sv/purchase-agent/cart-tmp/";